import { render, staticRenderFns } from "./StaleFileIcon.vue?vue&type=template&id=4cf21eab&scoped=true"
import script from "./StaleFileIcon.vue?vue&type=script&lang=js"
export * from "./StaleFileIcon.vue?vue&type=script&lang=js"
import style0 from "./StaleFileIcon.vue?vue&type=style&index=0&id=4cf21eab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf21eab",
  null
  
)

export default component.exports